var _defs, _text, _text2, _text3, _text4, _text5, _text6, _text7, _text8, _text9, _text10, _text11, _text12, _text13, _text14, _text15, _text16, _text17, _text18, _text19, _text20, _text21, _text22, _circle, _circle2, _circle3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    "data-name": "Calque 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 52.09 58.18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{font-size:8px;font-family:Melodrama-Medium, Melodrama;font-weight:500;}.cls-1,.cls-2{fill:#fff;}.cls-2{stroke:#1d1d1b;stroke-miterlimit:10;stroke-width:0.13px;}"))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "translate(15.94 18.13) rotate(-26.13)"
  }, "e")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "translate(20.1 16.25) rotate(-14.93)"
  }, "i")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "translate(21.38 15.8) rotate(-5.9)"
  }, "k")), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "translate(24.39 15.34) rotate(7.61)"
  }, "o")), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "matrix(0.92, 0.39, -0.39, 0.92, 28.87, 15.95)"
  }, "n")), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "translate(32.24 17.32) rotate(36.85)"
  }, "B")), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "matrix(0.69, 0.72, -0.72, 0.69, 35.23, 19.67)"
  }, "i")), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "translate(36.31 20.49) rotate(58)"
  }, "b")), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "matrix(0.35, 0.94, -0.94, 0.35, 38.75, 24.69)"
  }, "l")), _text10 || (_text10 = /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "translate(39.27 26.06) rotate(75.25)"
  }, "i")), _text11 || (_text11 = /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "translate(39.78 27.29) rotate(86.33)"
  }, "o")), _text12 || (_text12 = /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "translate(36.15 40.04) rotate(153.87)"
  }, "e")), _text13 || (_text13 = /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "translate(32 41.93) rotate(165.07)"
  }, "i")), _text14 || (_text14 = /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "matrix(-0.99, 0.1, -0.1, -0.99, 30.71, 42.38)"
  }, "k")), _text15 || (_text15 = /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "translate(27.71 42.84) rotate(-172.39)"
  }, "o")), _text16 || (_text16 = /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "translate(23.22 42.23) rotate(-157.13)"
  }, "n")), _text17 || (_text17 = /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "matrix(-0.8, -0.6, 0.6, -0.8, 19.85, 40.86)"
  }, "B")), _text18 || (_text18 = /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "matrix(-0.69, -0.72, 0.72, -0.69, 16.86, 38.51)"
  }, "i")), _text19 || (_text19 = /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "translate(15.78 37.69) rotate(-122)"
  }, "b")), _text20 || (_text20 = /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "matrix(-0.35, -0.94, 0.94, -0.35, 13.34, 33.49)"
  }, "l")), _text21 || (_text21 = /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "translate(12.83 32.11) rotate(-104.75)"
  }, "i")), _text22 || (_text22 = /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "translate(12.31 30.88) rotate(-93.67)"
  }, "o")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 13.36,
    cy: 20.25,
    r: 0.69
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 42.36,
    cy: 34.55,
    r: 0.69
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 26.09,
    cy: 30.04,
    r: 0.69
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.782dc2500ad8ca15e496ae99439df3a5.svg";
export { ForwardRef as ReactComponent };